import React from 'react'
import Radium from 'radium';

const Row = ({ children, style }) => (
    <div style={[styles.row, style]}>
        {children}
    </div>
);

const styles = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    }
}

export default Radium(Row);


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/spreadsheets/table/row.js